module.exports = __webpack_public_path__ + "static/kevincode-6e76d23507576d8eb2fd47d516e319a8.png";